import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';

import { initialize } from './core/auth/auth.actions';
import { AuthService } from './core/auth/auth.service';
import { HeaderComponent } from './core/layout/header/header.component';
import { LoaderComponent } from './core/layout/loader/loader.component';
import { SidebarComponent } from './core/layout/sidebar/sidebar.component';

@Component({
  selector: 'carehub-root',
  standalone: true,
  imports: [
    ConfirmDialogModule,
    HeaderComponent,
    LoaderComponent,
    RouterOutlet,
    SidebarComponent,
    ToastModule
],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnDestroy, OnInit {
  constructor(
    private authService: AuthService,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.store.dispatch(initialize());
  }

  ngOnDestroy(): void {
    this.authService.dispose();
  }
}
